const getCategoryKey = (id) => (id ? String(id).toLowerCase() : "");

export function getPartidaCategoryLabel(category, categories) {
  if (!category) return "";

  const byId = new Map(
    (categories || []).map((item) => [getCategoryKey(item.id), item])
  );
  const path = [];
  const visited = new Set();
  let current = category;

  while (current && !visited.has(getCategoryKey(current.id))) {
    path.unshift(current.descripcion || "");
    visited.add(getCategoryKey(current.id));
    current = byId.get(getCategoryKey(current.categoria_padre_id));
  }

  return path.join(" > ");
}

export function filterPartidaCategories(options, state) {
  const categories = options || [];
  const searchText = (state?.inputValue || "").trim().toLowerCase();
  if (!searchText) return categories;

  const byParent = new Map();
  const byId = new Map(categories.map((category) => [getCategoryKey(category.id), category]));
  categories.forEach((category) => {
    const parentId = getCategoryKey(category.categoria_padre_id);
    byParent.set(parentId, [...(byParent.get(parentId) || []), category]);
  });

  const visibleIds = new Set();
  const addDescendants = (categoryId) => {
    (byParent.get(getCategoryKey(categoryId)) || []).forEach((child) => {
      if (visibleIds.has(getCategoryKey(child.id))) return;
      visibleIds.add(getCategoryKey(child.id));
      addDescendants(child.id);
    });
  };
  const addAncestors = (category) => {
    let current = category;
    const visited = new Set();
    while (current && !visited.has(getCategoryKey(current.id))) {
      const currentId = getCategoryKey(current.id);
      visibleIds.add(currentId);
      visited.add(currentId);
      current = byId.get(getCategoryKey(current.categoria_padre_id));
    }
  };

  categories.forEach((category) => {
    const label = getPartidaCategoryLabel(category, categories).toLowerCase();
    const reference = (category.referencia || "").toLowerCase();
    if (!label.includes(searchText) && !reference.includes(searchText)) return;

    visibleIds.add(getCategoryKey(category.id));
    addAncestors(category);
    addDescendants(category.id);
  });

  return categories.filter((category) => visibleIds.has(getCategoryKey(category.id)));
}
